/**
 * A lista de permissões de um grupo.
 *
 * Estava escrita duas vezes, caractere por caractere, em `HomeScreen` e
 * `GroupsScreen`. Não vira componente do design system: `recurso.acao` é
 * vocabulário desta aplicação, e o portal não tem o que fazer com ele.
 */
export function PermissionList({
  permissions,
  empty,
}: {
  permissions: string[];
  empty: string;
}) {
  if (permissions.length === 0) {
    return <p className="text-sm text-texto-suave">{empty}</p>;
  }

  return (
    <ul className="flex flex-wrap gap-1.5">
      {permissions.map((p) => (
        <li
          key={p}
          className="rounded-pequeno bg-superficie-suave px-2 py-1 font-mono text-xs text-texto-suave"
        >
          {p}
        </li>
      ))}
    </ul>
  );
}
